import { Component } from '@theme/component';

class QuickAddButton extends Component {
  /** @type {AbortController | null} */
  #abortController = null;

  connectedCallback() {
    super.connectedCallback();

    this.#abortController = new AbortController();
    this.addEventListener('click', this.toggleQuickAddList, { signal: this.#abortController.signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController?.abort();
  }

  /**
   * Toggles the product card quick-add list.
   * @param {Event} event - The click event
   */
  toggleQuickAddList = (event) => {
    const target = event.target;
    if (!(target instanceof Element) || !target.closest('.quick-add-button__toggle')) return;

    event.preventDefault();

    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    const nextState = String(!isExpanded);
    const toggle = this.querySelector('.quick-add-button__toggle');

    this.setAttribute('aria-expanded', nextState);
    toggle?.setAttribute('aria-expanded', nextState);
  };
}

if (!customElements.get('quick-add-button')) {
  customElements.define('quick-add-button', QuickAddButton);
}
